<label for="upload" id="upload_btn">
    <span [innerHTML]="(fileName ? '<b>' + fileName + '</b>' : 'INPUT_FILE' | translate)"></span>
    <i class="icon-download" style="float: right"></i>
</label>
<input (change)="setFile($event)" accept=".docx"
       id="upload"
       type="file">
